import React from 'react';
import { Downgraded, useState } from '@hookstate/core';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { makeStyles } from '@mui/styles';
import CircleIcon from '@mui/icons-material/Circle';
import CachedIcon from '@mui/icons-material/Cached';
import { createTheme } from '@mui/material/styles';
import { participantStatus, MODULE_LIST } from '../../constants/Constant';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    paperContent: {
        // boxShadow:
        //     'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        // border: '1px solid #efefef',
        // width: '100%'
    },
    cardContent: {
        padding: '5px',
        '&:last-child': {
            paddingBottom: '5px',
        },
    },
    wrapper: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    icon: {
        fontSize: '1.5em',
    },
    count: {
        position: 'absolute',
        color: '#fff',
        fontWeight: 500,
        fontSize: '0.65em',
    },
}));

const ModuleHeaderCount = (props) => {
    const classes = useStyles();
    const { headerModuleList, onTotalClick, onModuleClick } = props;
    
    return (
        <Box sx={{ minWidth: 275 }}>
            <Card
                classes={{
                    root: classes.paperContent,
                }}
                variant="outlined"
                sx={{ mt: 2, mb: 2 }}>
                <CardContent
                    className={classes.cardContent}
                    sx={{
                        display: 'flex',
                        flexDirection: {
                            xs: 'column',
                            md: 'row',
                        },
                        width: '100%',
                    }}>
                    <Box
                        textAlign={'center'}
                        width={{
                            xs: '100%',
                            md: '75%',
                        }}>
                        <Tooltip sx={{ m: 1 }} title="Reset Filter">
                            <IconButton onClick={() => props.resetFilter()}>
                                <CachedIcon
                                    color="primary"
                                    fontSize="small"
                                />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    {headerModuleList.length > 0
                        ? headerModuleList
                            .attach(Downgraded)
                            .get()
                            .map((key, index) => {
                                if (key !== undefined) {
                                    return (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                width: {
                                                    xs: '100%',
                                                    // md: '10%',
                                                },
                                            }}
                                            key={index}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    justifyContent:
                                                        'space-around',
                                                    flexDirection: {
                                                        xs: 'column',
                                                        md: 'row',
                                                    },
                                                    width: {
                                                        xs: '100%',
                                                        md: '10rem',
                                                    },
                                                }}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection:
                                                            'column ',
                                                        marginLeft: '40px',
                                                    }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 14,
                                                            fontWeight: 500,
                                                            color: 'primary.main',
                                                        }}
                                                        textAlign={'center'}>
                                                        {key.module}
                                                    </Typography>
                                                    <Box
                                                    sx={{
                                                        display:'flex',
                                                        flexDirection:'column',
                                                    }}
                                                    >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                            justifyContent:
                                                                'center',
                                                            itemCenter:
                                                                'center',
                                                        }}>

                                                        <CountItem
                                                            title={`Total : ${((key.participanttodocount ? key.participanttodocount :  key.todoCount) +
                                                                (key.participantpendingcount ? key.participantpendingcount  :  key.pendingCount) +
                                                                (key.participantapprovedcount ? key.participantapprovedcount :   key.approvedCount))
                                                                }`}
                                                            onClick={() =>
                                                                onTotalClick(
                                                                    key
                                                                )
                                                            }
                                                            count={((key.participanttodocount ? key.participanttodocount :  key.todoCount) +
                                                                (key.participantpendingcount ? key.participantpendingcount  :  key.pendingCount) +
                                                                (key.participantapprovedcount ? key.participantapprovedcount :   key.approvedCount))}
                                                            color={'#958e8e'}
                                                        />

                                                        <CountItem
                                                            title={`To Do : ${key.participanttodocount ? key.participanttodocount :  key.todoCount}`}
                                                            onClick={() =>
                                                                onModuleClick(
                                                                    key,
                                                                    'To Do',
                                                                    0
                                                                )
                                                            }
                                                            count={key.participanttodocount ? key.participanttodocount :  key.todoCount }
                                                            color={participantStatus[0]
                                                                .name}
                                                        />

                                                        <CountItem
                                                            title={`Pending : ${key.participantpendingcount ? key.participantpendingcount  :  key.pendingCount}`}
                                                            onClick={() =>
                                                                onModuleClick(
                                                                    key,
                                                                    'Pending',
                                                                    1
                                                                )
                                                            }
                                                            count={key.participantpendingcount ? key.participantpendingcount  :  key.pendingCount }
                                                            color={participantStatus[1]
                                                                .name}
                                                        />


                                                        <CountItem
                                                            title={`Approved : ${key.participantapprovedcount ? key.participantapprovedcount :   key.approvedCount}`}
                                                            onClick={() =>
                                                                onModuleClick(
                                                                    key,
                                                                    'Approved',
                                                                    2
                                                                )
                                                            }
                                                            count={key.participantapprovedcount ? key.participantapprovedcount :   key.approvedCount} 
                                                            color={participantStatus[2]
                                                                .name}
                                                        />

                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                            justifyContent:
                                                                'center',
                                                            itemCenter:
                                                                'center',
                                                        }}>

                                                        <CountItem
                                                            title={`Total : ${key.todoCount +
                                                                key.pendingCount +
                                                                key.approvedCount
                                                                }`}
                                                            onClick={() =>
                                                                onTotalClick(
                                                                    key
                                                                )
                                                            }
                                                            count={key.todoCount +
                                                                key.pendingCount +
                                                                key.approvedCount}
                                                            color={'#958e8e'}
                                                        />

                                                        <CountItem
                                                            title={`To Do : ${key.todoCount}`}
                                                            onClick={() =>
                                                                onModuleClick(
                                                                    key,
                                                                    'To Do',
                                                                    0
                                                                )
                                                            }
                                                            count={key.todoCount}
                                                            color={participantStatus[0]
                                                                .name}
                                                        />

                                                        <CountItem
                                                            title={`Pending : ${key.pendingCount}`}
                                                            onClick={() =>
                                                                onModuleClick(
                                                                    key,
                                                                    'Pending',
                                                                    1
                                                                )
                                                            }
                                                            count={key.pendingCount}
                                                            color={participantStatus[1]
                                                                .name}
                                                        />


                                                        <CountItem
                                                            title={`Approved : ${key.approvedCount}`}
                                                            onClick={() =>
                                                                onModuleClick(
                                                                    key,
                                                                    'Approved',
                                                                    2
                                                                )
                                                            }
                                                            count={key.approvedCount}
                                                            color={participantStatus[2]
                                                                .name}
                                                        />

                                                      </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    );
                                }

                            })
                        : null}
                </CardContent>
            </Card>
        </Box>
    )
}


export default ModuleHeaderCount;

const CountItem = (props) => {
    const classes = useStyles();
    return (
        <Tooltip
            title={props.title}>
            <Box
                className={
                    classes.wrapper
                }
                style={{
                    fontSize: 16,
                }}
                onClick={props.onClick}>
                <CircleIcon
                    className={
                        classes.icon
                    }
                    style={{
                        color: props.color,
                    }}
                />
                <Typography
                    component="span"
                    className={
                        classes.count
                    }>
                    {
                        props.count
                    }
                </Typography>
            </Box>
        </Tooltip>
    )
}